module.exports = "/_next/static/images/a711b6bd19197560cca5ce5869cb2137-pay-yourself-md@1x.jpg";